import React from "react";

// A screen that fails while drawing shows this instead of a blank white page.
export default class ErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Screen crashed:", error, info && info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center", fontFamily: "Roboto, Arial, sans-serif", background: "#f6f5f0" }}>
        <h2 style={{ margin: "0 0 8px", color: "#1B2420" }}>Something went wrong</h2>
        <p style={{ margin: "0 0 20px", color: "#5B6660", maxWidth: 420 }}>This page hit an unexpected problem. Your data is safe. Reload the page to continue.</p>
        <button
          onClick={() => window.location.reload()}
          style={{ background: "#1f7a54", color: "#fff", border: "none", borderRadius: 10, padding: "10px 24px", fontWeight: 700, fontSize: 15, cursor: "pointer" }}
        >
          Reload page
        </button>
      </div>
    );
  }
}
